import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { forOwn, isPlainObject, isArray } from 'lodash-es';

export const numberInterceptor: HttpInterceptorFn =
  (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    return next(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.body) {
          numberFix(event.body);
        }
      })
    );
  };

function numberFix(object: any) {
  try {
    forOwn(object, (value, key) => {
      if (isPlainObject(value) || isArray(value)) {
        numberFix(value);
      } else if (value != null && isNumber(value)) {
        object[key] = Number(value);
      }
    });
  }
  catch {

  }
}


function isNumber(value: any): boolean {
  if (typeof value !== 'string') return false;
  if (value.length >= 10) return false;
  if (/[^0-9.\-+eE]/.test(value)) return false;
  if (value.length === 0) return false;
  
  // Disallow leading zero after optional sign
  const unsigned = value.replace(/^[+-]/, '');
  if (unsigned.startsWith('0')) return false;

  const num = Number(value);
  return !isNaN(num) && isFinite(num);
}



/*
import { tap } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { forOwn, isPlainObject, isArray } from 'lodash-es';

//Conver string to number
@Injectable()
export class numberInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req.clone()).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
        if (event) {
          if (event.body) {
            this.NumberFix(event.body);
          }
        }
      }
    }));
  }

  NumberFix(object: any) {
    forOwn(object, (value, key, object) => {
      if (isPlainObject(value)) {
        this.NumberFix(value);
      } else if (isArray(value)) {
        this.NumberFix(value);
      }
      else {
        if (value) {
          if (this.isNumber(value)) {
            console.log('converting to number', value);
            object[key] = new Number(value);
          }
        }
      }
    })
  }

  isNumber(value: any): boolean {
    if (typeof value !== 'string') return false;
    if (value.length > 16) return false;

    // Reject if it contains non-numeric characters (excluding . and -)
    if (/[^0-9.\-+eE]/.test(value)) return false;

    // Check if it can be safely converted to a number
    const num = Number(value);
    return !isNaN(num) && isFinite(num);
  }
}
*/
